import i18n from '../../language/index'
import { create_title } from '@/base/titleData'
import {
  basic_classification_new_style
} from '@/base/widgets_data_compatible';
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    icon: {
      radio_val: 'custom',
      default: {
        icon_position: 'right', // left 左边 right 右边
        icon_url: 'https://sitecdn.71360.com/static/txys-001/image/arrow.png', //图标
        icon_width: 20,
      },
      custom: {
        icon_position: 'right', // left 左边 right 右边
        icon_url: 'https://sitecdn.71360.com/static/txys-001/image/arrow.png', //图标
        icon_width: 20,
      }
    },
    font_level_1: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_level_1:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_level_1: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_level_1: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    font_level_2: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_level_2:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_level_2: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_level_2: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    font_level_3: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_level_3:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_level_3: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_level_3: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    font_detail_nav: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_detail_nav: {
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)',
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)',
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_detail_nav: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_detail_nav: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    linkType: '_blank',
    title: create_title('Classification'),
    ...basic_classification_new_style()
  },
  mb_widgets_infor: {
    icon: {
      radio_val: 'custom',
      default: {
        icon_position: 'right', // left 左边 right 右边
        icon_url: 'https://sitecdn.71360.com/static/txys-001/image/arrow.png', //图标
        icon_width: 20,
      },
      custom: {
        icon_position: 'right', // left 左边 right 右边
        icon_url: 'https://sitecdn.71360.com/static/txys-001/image/arrow.png', //图标
        icon_width: 20,
      }
    },
    font_level_1: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_level_1:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_level_1: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_level_1: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    font_level_2: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_level_2:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_level_2: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_level_2: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    font_level_3: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_level_3:{
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_level_3: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_level_3: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    font_detail_nav: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    background_detail_nav: {
      radio_val: 'default',
      default: {
        color: 'rgba(255, 255, 255,1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)',
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)',
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    lineHeight_detail_nav: {
      radio_val: 'default',
      default: {
        lineHeight: 38
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine_detail_nav: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 0,
        borderStyle: 'solid'
      }
    },
    title: create_title('Classification'),
    icon_position: 'right', // left 左边 right 右边
    icon_url: '', //图标
  },
  listArr: {
    classificationType: 'productList',// 分类类型productList,newsList,caseList,helpList
    classificationSelect: 'all', // 分类选择类型all,appoint,navbar
    filterByIds: [],
    ...basic_classification_new_style().navbarByIds,
    ...basic_classification_new_style().navbarByThemeName,
    ...basic_classification_new_style().textAlign,
    moduleStyle: 0,
    child_trigger: 'default_open', // default_open 默认展开 click_open 点击展开 hover_open 悬停展开
    appoint_child_trigger: 'no_expand', // no_expand 不展开 click_expand 点击展开 all_expand 全部展开
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_classification/style.js